import { render, staticRenderFns } from "./QScoreCardFilters.vue?vue&type=template&id=39108042&scoped=true&"
import script from "./QScoreCardFilters.vue?vue&type=script&lang=js&"
export * from "./QScoreCardFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39108042",
  null
  
)

export default component.exports